import { c as click, q as qs, h as hasClass, i as setClassWhenTrue, o as onReady, j as initMagic } from './app-chunk-common-BPZAsnhF.js';
import './app-bundle.vendor.js';
import './app-chunk-vendor-modules-m0hYGuxH.js';

const tagbarSelector = ".blog-tagbar";
const toggleMoreSelector = ".blog-tagbar__toggle-more";
const expandedClass = "is-expanded";

var initBlogs = () => {
  click(toggleMoreSelector, (btn) => {
    const tagbar = qs(tagbarSelector);
    const isExpanded = hasClass(tagbar, expandedClass) === false;
    setClassWhenTrue(tagbar, expandedClass, isExpanded);
    btn.blur();
  });
};

onReady(() => {
  initBlogs();
  initMagic();
});
